/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_IndexInputs */

const en_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const ar_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#فهرس`)
};

const bn_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const de_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const es_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const fr_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const pt_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const zh_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const tr_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const ru_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

const pl_svtag_index = /** @type {(inputs: Svtag_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#INDEX`)
};

/**
* | output |
* | --- |
* | "#INDEX" |
*
* @param {Svtag_IndexInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_index = /** @type {((inputs?: Svtag_IndexInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_IndexInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_index(inputs)
	if (locale === "bn") return bn_svtag_index(inputs)
	if (locale === "de") return de_svtag_index(inputs)
	if (locale === "es") return es_svtag_index(inputs)
	if (locale === "fr") return fr_svtag_index(inputs)
	if (locale === "pt") return pt_svtag_index(inputs)
	if (locale === "zh") return zh_svtag_index(inputs)
	if (locale === "tr") return tr_svtag_index(inputs)
	if (locale === "ru") return ru_svtag_index(inputs)
	if (locale === "pl") return pl_svtag_index(inputs)
	return en_svtag_index(inputs)
});